<template>
  <div class="form-container" style="position: relative;">
    <el-form ref="form" label-position="top" :rules="rules" :model="formPassWord" class="product-form">
      <el-row>
        <el-col :span="24">
          <el-form-item style="width: 30%">
            <label slot="label">{{ $t('old_password') }}</label>
            <el-input class="gray-theme" show-password :placeholder="$t('enter_old_password')" v-model="formPassWord.password" maxlength="20"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item style="width: 60%;margin-bottom: 0" prop="newPassword">
            <label slot="label">{{ $t('new_password') }}</label>
            <el-input class="gray-theme" show-password :placeholder="$t('enter_new_password')" v-model="formPassWord.newPassword" maxlength="20"></el-input>
          </el-form-item>
          <div class="password-info" style="width: 58%">{{ $t('password_least') }}</div>
        </el-col>
        <el-col :span="12">
          <el-form-item style="width: 60%" prop="confirmPassword">
            <label slot="label">{{ $t('confirm_password') }}</label>
            <el-input class="gray-theme" show-password :placeholder="$t('enter_confirm_password')" v-model="formPassWord.confirmPassword" maxlength="20"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import authApi from '@/apis/auth-api';

export default {
  data() {
    var checkPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('input_password_again')));
      } else if (value !== this.formPassWord.newPassword) {
        callback(new Error(this.$t('password_error_two')));
      } else {
        callback();
      }
    };
    return {
      formPassWord: {
        password: '',
        newPassword: '',
        confirmPassword: ''
      },
      dialogVisible: false,
      moduleListData: [],
      rules: {
        confirmPassword: [{ validator: checkPass, trigger: 'blur' }]
      }
    };
  },

  model: {
    prop: 'modelData',
    event: 'change'
  },

  props: {
    modelData: {
      type: Object,
      default: () => {}
    }
  },

  components: {},

  computed: {},

  mounted() {
    this.init();
  },

  beforeDestroy() {},

  watch: {},

  methods: {
    init() {
    },

    Submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.modifyPassword();
        } else {
          return false;
        }
      });
    },

    async modifyPassword() {
      const reqPassword = {
        ...this.formPassWord
      };
      const resPassword = await authApi.changePassword(reqPassword);
      if (resPassword.reason) {
        this.$message({
          message: this.$t('old_password_error'),
          type: 'error',
          center: true,
          duration: 5000
        });
      } else {
        this.$message({
          message: this.$t('update_password_success'),
          type: 'success',
          center: true,
          duration: 5000
        });
        this.$emit('closeAction', false);
      }
    }
  }
};
</script>

<style lang="scss">
.product-form {
  .el-form-item__label {
    float: left !important;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    color: #292929;
    padding: 0 !important;
  }
  .el-form-item__content {
    text-align: left;
    .el-textarea__inner {
      height: 80px;
    }
  }
}

.el-divider {
  background: #c7c8c9;
}

.price-suffix {
  .el-input__inner {
    padding-right: 90px;
  }
}

.suffix-title {
  font-size: 16px;
  color: #292929;
}

.password-info {
  width: 300px;
  font-size: 12px;
  text-align: left;
  color: #292929;
  line-height: 12px;
  word-break: break-word;
}
</style>
